<template>
  <div class="row">
    <div class="col-12">
      <div class="row">
        <div class="col-sm-6 offset-sm-3 border border-secondary brs p-3 text-center">
          <div class="h-100 pt-3">
            <div class="d-flex justify-content-center align-items-center">
              <img
                src="@/assets/img/tick_selector.png"
                class="img-fluid d-inline-block"
                alt="Transfer complete"
              />
              <h4 class="d-inline-block my-auto pl-2">Transfer Complete</h4>
            </div>
            <div class="mt-4 font-weight-bold">
              <a href="#" class="underline" @click="oldCustomer">
                1 -
                View old customer
              </a>
            </div>
            <div class="mt-4 font-weight-bold pb-3">
              <a href="#" class="underline" @click="newCustomer">
                2
                - View new customer
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    transferResponse() {
      return this.$store.state.transfer.transferResponse;
    }
  },
  methods: {
    oldCustomer() {
      document.getElementById("Transfer").click();
      this.$store.dispatch("refreshCustomerData");
    },
    newCustomer() {
      document.getElementById("Transfer").click();
      this.$store.dispatch(
        "setCustomer",
        this.transferResponse.CustomerReference
      );
      this.$router.push(
        "/dashboard/" + this.transferResponse.CustomerReference
      );
    }
  }
};
</script>